<template>
  <div
    :class="`ticket-input`"
    >
    <ul :class="wrongNumberAnimating ? 'error' : ''" class="output" ref="number">
      <li class="label">N°</li>
      <li v-for="(index, i) in maxChars" :key="i" :class="getSymbol(index - 1, false) < 0 ? 'hide' : 'show'"><span v-html="getSymbol(index - 1)"></span></li>
      <li class="clear">
        <button @click="reset"></button>
      </li>
    </ul>
    <div class="keyboard-container">
      <transition v-bind:css="false" @enter="keyboardTransition.enter" @leave="keyboardTransition.leave" :mode="keyboardTransition.mode" appear>
        <inline-keyboard :layout="keyboardLayout" @press="keyPress"></inline-keyboard>
      </transition>
    </div>
  </div>
</template>
<script>
import customMessageBase from '@/components/mixins/customMessageBase'
import InlineKeyboard from './InlineKeyboard'
import numericLayout from '@/components/ui/keyboards/numeric'
import keyboardTransition from '../../transitions/fadeInUp'
import { TweenMax, Power4 } from 'gsap'

export default {
  components: { InlineKeyboard },
  name: 'ticket-input',
  mixins: [customMessageBase],
  methods: {
    reset () {
      this.customMessage = ''
    },
    wrongNumber () {
      if (this.wrongNumberAnimating) {
        return
      }

      let vm = this
      this.wrongNumberAnimating = true
      TweenMax.to(this.$refs.number, 0.1, {
        marginLeft: '+=30',
        yoyo: true,
        repeat: 5,
        ease: Power4.easeInOut,
        onComplete: () => {
          vm.wrongNumberAnimating = false
        }
      })
    },
    getSymbol (index, normalize = true) {
      if (this.customMessage.length > index) {
        let number = parseInt(this.customMessage[index], 10)
        if (!isNaN(number)) {
          return number.toString()
        }
      }

      if (!normalize) {
        return -1
      }
      return this.normalizeSymbol(' ')
    }
  },
  computed: {
    keyboardLayout () {
      return numericLayout
    }
  },
  data () {
    return {
      keyboardTransition,
      wrongNumberAnimating: false
    }
  }
}
</script>
<style lang="scss" scoped>
  @keyframes show {
    0% {
      opacity: 0;
      top: 30px;
    }
    100% {
      opacity: 1;
      top: 0;
    }
  }

  .ticket-input {
    .label {
      margin-top: 10px;
      font-size: 10px;
      margin-left: -30px;
    }

    .clear {
      margin-top: 10px;
      font-size: 16px;
      margin-left: -30px;
    }

    ul.output {
      &.error {
        li {
        color: red;
          border-bottom: 8px solid red;
        }
      }
      &, li {
        text-align: center;
        text-transform: uppercase;
        display: inline-block;
      }
    }

    ul.output li {
      font-size: 80px;
      font-weight: bold;
      margin-left: 8px;
      margin-right: 8px;
      font-weight: 600;
      text-align: center;
      width: 60px;
      line-height: 130%;
      position: relative;
      border-bottom: 8px solid #000;
      margin-bottom: 50px;
      position: relative;
      float: left;
      height: 110px;

      &.show span {
        animation: show 0.2s linear;
      }

      span {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        text-align: center;
      }

      &.label, &.clear {
        border-bottom: none;
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
      }
      &.clear button {
        position: relative;
        border: 1px solid #000;
        border-radius: 50%;
        width: 64px;
        height: 64px;
        padding: 15px;
        display: inline-block;
        background: transparent url('../../assets/close-button.svg') center center no-repeat;
        background-size: 50% 50%;
        margin: 0;
      }
      &.label {
        font-size: 40px;
      }
    }
  }
  .keyboard-container {
    width: 100%;
    display: flex;
    justify-content: center;
    .inline-keyboard {
      width: 50%;
    }
  }

  .ticket-input1024x768 {
    .label {
      margin-top: 1px;
      font-size: 16px;
      margin-left: -0px !important;
    }
    .clear {
      margin-top: 10px;
      font-size: 16px;
      margin-left: -30px;
    }

    ul.output li {
      font-size: 40px;
      margin-left: 8px;
      margin-right: 8px;
      width: 55px;
      line-height: 340%;
      border-bottom: 8px solid #000;
      margin-bottom: 10px;
      height: 108px;

      &.clear button {
        width: 58px;
        height: 58px;
      }
    }
  }
</style>
